import { useMemo } from 'react';
import { TourType } from '@/Components/Tour/Tour';
import { useLocalization } from '@/Hooks';

export function useOrderAutomationSettings() {
  const {
    tours: {
      OrderAutomationSettings: { Default },
    },
  } = useLocalization();

  const pageTour = useMemo<TourType>(
    () => ({
      id: 'pageTour',
      title: Default.Title,
      steps: [
        {
          content: Default.Step1.Text,
          placement: 'auto',
          target: '.automationBlock',
          title: Default.Step1.Title,
          disableBeacon: true,
          link: Default.Step1.DetailsLink,
        },
      ],
    }),
    [Default],
  );

  return [pageTour];
}
